import { atom } from "recoil"

export const inboxContactsConcatRequestIdState = atom({
  key: "atoms/contact/inboxContactsConcatRequestIdState",
  default: 0,
})
